import { ENV, WINDOW_ENV } from './types';

export * from './types';

export const isStaging = () => environmentVariable(ENV.STAGE) === 'staging';
export const isProduction = () => environmentVariable(ENV.STAGE) === 'prod';
export const isDev = () => environmentVariable(ENV.STAGE) === 'dev';

export const environmentVariable = (key: ENV | WINDOW_ENV) => {
  const value =
    process.env[key as keyof typeof process.env] ??
    (typeof window !== 'undefined' ? window.env[key] : null);
  if (!value) {
    throw new Error(`Missing env ${key.toString()}`);
  }
  return value.replace(/\n/g, '\n').replace(/\\n/g, '\n');
};

export const processEnvToWindowEnv = (): Window['env'] => {
  const test: any = {};
  // eslint-disable-next-line no-restricted-syntax
  for (const key of Object.keys(WINDOW_ENV)) {
    test[key as any] = environmentVariable(key as any);
  }
  return test;
};

export const verifiyEnvironmentVariables = () => {
  const missingKeys: string[] = [];
  console.log('Verifying environment variables..\n');
  // eslint-disable-next-line no-restricted-syntax
  for (const key of Object.keys(ENV)) {
    const value = process.env[key as keyof typeof process.env];
    if (!value) {
      missingKeys.push(key);
    }
    console.log(`[${key}]: ${!value ? 'MISSING' : `OK (${value.replace(/\\n/g, '\n')})`}`);
  }
  if (missingKeys.length) {
    console.log(`\nMissing keys: ${missingKeys.join(' | ')}\n`);
  }
  console.log('\nEnvironment variables verified!');
};
